import { Column, Entity, JoinColumn, ManyToOne, PrimaryColumn } from 'typeorm';
import { Lieu } from '.';
import { Client } from './client.entity';

@Entity('client_lieu')
export default class ClientLieu {
    @PrimaryColumn()
    fk_id_client: number;

    @ManyToOne(() => Client, (client) => client.id, { eager: true })
    @JoinColumn({ name: 'fk_id_client' })
    client: Client;

    @PrimaryColumn()
    fk_id_lieu: number;

    @ManyToOne(() => Lieu, (lieu) => lieu.id, { eager: true })
    @JoinColumn({ name: 'fk_id_lieu' })
    lieu: Lieu;

    @Column({ type: 'text', nullable: true })
    detail: string;
}
